import { LitElement, html, css } from "lit";
import "@matter/matter-image";

class MatterSlider extends LitElement {
  static styles = css`
    :host {
      display: block;
      font-family: Source Sans Pro, sans-serif;
      --main: #087021;
      /* Total del viewport  - (75% del slider - 50px del offset)  */
      --subtitle-width-sm: calc(100vw - ((0.75 * 510px) - 50px));
      --subtitle-width-md: calc(100vw - ((0.75 * 690px) - 50px));
      --subtitle-width-lg: calc(100vw - ((0.75 * 930px) - 50px));
      --subtitle-width-xl: calc(100vw - ((0.75 * 1110px) - 50px));
      --subtitle-width-xxl: calc(100vw - ((0.75 * 1245px) - 50px));
    }
    * {
      box-sizing: border-box;
    }

    :host([play]) .pause {
      display: inline-block;
    }

    :host([arrows]) .prev,
    :host([arrows]) .next {
      display: block;
    }

    .slideshow-container {
      position: relative;
      margin: auto;
      width: 100%;
    }

    .slide {
      display: none;
    }

    .prev,
    .next {
      cursor: pointer;
      position: absolute;
      top: 50%;
      width: auto;
      margin-top: -22px;
      padding: 16px;
      color: #ffffff;
      font-weight: bold;
      font-size: 32px;
      transition: 0.6s ease;
      border-radius: 0 3px 3px 0;
      user-select: none;
      display: none;
    }

    .next {
      right: 0;
      border-radius: 3px 0 0 3px;
    }

    .bottom_section {
      
      padding: 8px 50px;
      position: absolute;
      top: 40%;
      transform: translateY(-50%);
      text-align: left;
    }
    
    @media only screen and (min-width: 576px) {
      .bottom_section {
        padding: 8px 12px;
        top: 50px;
        left: 40px;
        transform: unset;
      }

    }

   
    .title {
      color: #ffffff;
      font-family: "Montserrat", sans-serif;
      font-size: 20px;
      font-weight: bold;
      line-height: 29px;
      /*overflow: hidden;*/
      white-space: pre-line;
      text-overflow: ellipsis;
    }

    .subtitle {
      color: #ffffff;
      text-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
      font-family: "Source Sans Pro";
      font-style: normal;
       font-weight: 550;
      font-size: 17px;
      line-height: 25px;
      margin-top: 16px;
    }
    

    @media only screen and (min-width: 576px) {
      .title{
        font-size: 24px;
      }
      .subtitle {
        max-width: var(--subtitle-width-sm);
      }
    }

    @media only screen and (min-width: 768px) {
      .title {
        font-size: 32px;
      }
      .subtitle {
        max-width: var(--subtitle-width-md);
      }
    }

    @media only screen and (min-width: 992px) {
      .subtitle {
        max-width: var(--subtitle-width-lg);
      }
    }

    @media only screen and (min-width: 1200px) {
      .subtitle {
        max-width: var(--subtitle-width-xl);
      }
    }

    @media only screen and (min-width: 1300px) {
      .subtitle {
        max-width: var(--subtitle-width-xxl);
      }
    }

   

    .btn {
      color: #ffffff;
      background-color: var(--main);
      text-transform: uppercase;
      text-decoration: none;
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
      padding: 10px 33px;
      display: inline-flex;
      margin-top: 30px;
      border-radius: 5px;
    }

    .circle_paginate {
      //padding: 8px 12px;
      position: absolute;
      left: 50px;
      bottom: 34px;
      //width: 100%;
      //text-align: left;
      //padding-left: 107px;
    }
    
    @media only screen and (min-width: 576px) {
      .circle_paginate {
        bottom: 44px;
      }
    }

    .pause {
      cursor: pointer;
      height: 12px;
      width: 15px;
      margin: 0 2px;
      font-size: 18px;
      color: #ffffff;
      vertical-align: 1px;
      display: none;
    }

    .dot {
      cursor: pointer;
      height: 15px;
      width: 15px;
      margin: 0 2px;
      background: transparent;
      border-radius: 50%;
      border: 1px solid #ffffff;
      display: inline-block;
      transition: background-color 0.6s ease;
    }

    .active,
    .dot:hover {
      background-color: #ffffff;
    }

    /* .fade {
      -webkit-animation-name: fade;
      -webkit-animation-duration: 1.5s;
      animation-name: fade;
      animation-duration: 1.5s;
    } */

    .container {
      position: relative;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      clear: float;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 40%);
      color: #ffffff;
    }

    .secondary-overlay {
      position: absolute;
      top: 0;
      left: 0;
      clear: float;
      float: right;
      margin-left: 71%;
      width: 29%;
      height: 100%;
      background-color: #087021;
      opacity: 0.8;
      color: #ffffff;
    }

    .secondary_next {
      right: 29%;
    }

    /* @-webkit-keyframes fade {
      from {
        opacity: 0.2;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes fade {
      from {
        opacity: 0.2;
      }
      to {
        opacity: 1;
      }
    } */

    /* On smaller screens, decrease text size */
    @media only screen and (max-width: 420px) {
      .title {
        overflow: hidden;
        white-space: pre-line;
        text-overflow: ellipsis;
      }

      //.secondary-overlay {
      //  position: absolute;
      //  top: 50%;
      //  left: 0;
      //  clear: float;
      //  float: right;
      //  margin-left: 0%;
      //  width: 100%;
      //  height: 50%;
      //  background-color: #087021;
      //  opacity: 0.8;
      //  color: #ffffff;
      //}

      .secondary_title:first-line {
        line-height: 10px;
      }

      /* :host([arrows]) .prev, */
      /* :host([arrows]) .next { */
      /*display: none;*/
      /* } */
    }

    @media only screen and (max-width: 425px) {
      //.bottom_section {
      //  padding: 8px 50px;
      //  top: 50%;
      //  transform: translateY(-50%);
      //}
      .title {
        overflow: inherit;
      }
    }
  `;

  static get properties() {
    return {
      initial: { type: Number },
      endpointURL: { type: String },
      images: { type: Array },
      arrows: { type: Boolean, reflect: true },
      pause: { type: Boolean },
      play: { type: Boolean, reflect: true },
      seconds: { type: Number },
      height: { type: String },
      secondary: { type: Boolean },

      inputTitle: { type: String },
      inputSubtitle: { type: String },
      inputBtnText: { type: String },
      inputUrl: { type: String },
      inputTarget: { type: String },
      inputAlt: { type: String },
      inputPhoto: { type: String },

      _response: { type: Array },
      _error: { type: String },
      _aux: { type: Number },
    };
  }

  constructor() {
    super();
    this.initial = 1;
    this.arrows = false;
    this.pause = false;
    this.play = false;
    this.seconds = 5;
    this.height = "450px";
    this.endpointURL = "";
    this.secondary = false;
    this.images = [];

    this.inputTitle = "";
    this.inputSubtitle = "";
    this.inputBtnText = "";
    this.inputUrl = "";
    this.inputTarget = "";
    this.inputAlt = "";
    this.inputPhoto = "";

    this._response = [];
    this._error = "";
    this._aux = null;
  }

  render() {
    return html`
      <div class="slideshow-container">
        ${this._error
          ? html` <div class="error">${this._error}</div> `
          : this._response.map(
              (image) =>
                html`
                  <div class="slide fade">
                    ${this.secondary
                      ? html`
                          <div class="container">
                            <matter-image
                              src=${image.photo}
                              alt=${image.alt}
                              sizing="cover"
                              position="center"
                              width="100%"
                              height="${this.height}"
                            >
                            </matter-image>
                            <div class="secondary-overlay"></div>
                          </div>
                          <div class="secondary_bottom_section">
                            <div class="secondary_sect_text">
                              <div
                                class="title  secondary_title"
                                role="region"
                                aria-label="${image.title}"
                              >
                                ${image.title}
                              </div>
                              <div class="description secondary_description">
                                ${image.description}
                              </div>
                              <div>
                                <a
                                  href="${image.url}"
                                  target="${image.target}"
                                  class="enlace"
                                  >&#9205; Mas información</a
                                >
                              </div>
                            </div>
                          </div>
                        `
                      : html`
                          <div class="container">
                            <matter-image
                              src=${image.photo}
                              alt=${image.alt}
                              sizing="cover"
                              position="center"
                              width="100%"
                              height="${this.height}"
                            >
                            </matter-image>
                            <div class="overlay"></div>
                          </div>
                          <div class="bottom_section">
                            <div class="sect_text">
                              <div
                                class="title"
                                role="region"
                                aria-label="${image.title}"
                              >
                                ${image.title}
                              </div>
                              <div class="subtitle">
                                ${image.subtitle.length > 91
                                    ? html`
                                            ${image.subtitle.substring(0,91)}...
                                        `
                                    : html`${image.subtitle}`}
                                
                              </div>
                            </div>
                            <div class="sect_btn">
                              <a class="btn" href="${image.url}"
                                >${image.btnText}</a
                              >
                            </div>
                          </div>
                        `}
                  </div>
                `
            )}

        <div class="circle_paginate" role="region" aria-label="pause">
          <span class="pause" @click="${this.currentPause}"
            >&#10074;&#10074;</span
          >
          ${this._response.map(
            (_image, index) => html`
              <span
                class="dot"
                data-slide="${index + 1}"
                @click=${this.currentSlide}
              ></span>
            `
          )}
        </div>
        <a
          role="region"
          aria-label="prev"
          class="prev"
          data-slide=${this.initial - 1}
          @click=${this.currentSlide}
          >&#10094;</a
        >
        ${this.secondary
          ? html`
              <a
                role="region"
                aria-label="next"
                class="next secondary_next"
                data-slide=${this.initial + 1}
                @click=${this.currentSlide}
                >&#10095;</a
              >
            `
          : html`
              <a
                role="region"
                aria-label="next"
                class="next"
                data-slide=${this.initial + 1}
                @click=${this.currentSlide}
                >&#10095;</a
              >
            `}
      </div>
      <br />
    `;
  }

  firstUpdated() {
    this.updatedResponse();
    this.addFont();
  }

  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  updated(changedProperties) {
    changedProperties.forEach((_, propName) => {
      if (["seconds", "play"].includes(propName)) {
        this.setupButtonListeners();
        this.updateInterval();
      }
      if (["_response"].includes(propName)) {
        this.showSlides(this.initial, this.play);
      }
    });
  }

  async updatedResponse() {
    this._error = null;

    try {
      const response = await fetch(this.endpointURL);
      if (response.ok) {
        const json = await response.json();

        const elements = [];
        json.slice(0, 5).forEach((item) => {
          const title = item[this.inputTitle] ? item[this.inputTitle] : "";
          const subtitle = item[this.inputSubtitle]
            ? item[this.inputSubtitle]
            : "";
          const btnText = item[this.inputBtnText]
            ? item[this.inputBtnText]
            : "";
          const url = item[this.inputUrl] ? item[this.inputUrl] : "";
          const target = item[this.inputTarget] ? item[this.inputTarget] : "";
          const alt = item[this.inputAlt] ? item[this.inputAlt] : "";
          const photo = item[this.inputPhoto] ? item[this.inputPhoto] : "";

          elements.push({
            title,
            subtitle,
            btnText,
            url,
            target,
            alt,
            photo,
          });
        });

        this._response = elements;
      }
    } catch (error) {
      // handle errors
    }
  }

  updateInterval() {
    clearInterval(this._aux);
    this._aux = setInterval(() => {
      this.showSlides(this.initial + 1, this.play);
    }, this.seconds * 1000);
  }

  setupButtonListeners() {
    const dots = this.shadowRoot.querySelectorAll(".dot");
    dots.forEach((dot) => {
      dot.addEventListener("click", this.currentSlide.bind(this));
    });

    const pauseButton = this.shadowRoot.querySelector(".pause");
    pauseButton.addEventListener("click", this.currentPause.bind(this));
  }

  showSlides(n, play) {
    const slides = this.shadowRoot.querySelectorAll(".slide");
    const dots = this.shadowRoot.querySelectorAll(".dot");

    if (
      slides[this.initial - 1] !== undefined ||
      slides[this.initial - 1] != null
    ) {
      slides[this.initial - 1].style.display = "none";
      dots[this.initial - 1].className = dots[
        this.initial - 1
      ].className.replace(" active", "");

      if (play) {
        if (n < 1) {
          this.initial = slides.length;
        } else {
          this.initial = Math.max(n % (slides.length + 1), 1);
        }
      }

      slides[this.initial - 1].style.display = "block";
      dots[this.initial - 1].className += " active";
    }
  }

  currentSlide(e) {
    this.showSlides(e.currentTarget.getAttribute("data-slide"), true);
  }

  currentPause() {
    this.pause = !this.pause;
    if (this.pause) {
      this.shadowRoot.querySelector(".pause").innerHTML = "&#9654;";
      clearInterval(this._aux);
    } else {
      this.shadowRoot.querySelector(".pause").innerHTML = "&#10074;&#10074;";
      this.updateInterval();
    }
  }
}

if (!window.customElements.get("matter-slider")) {
  window.customElements.define("matter-slider", MatterSlider);
}
